// extracted by mini-css-extract-plugin
module.exports = {"incident-info":"styles_incident-info_3yN-Hhl3BY8B3aQNJrNyr2","incidentInfo":"styles_incident-info_3yN-Hhl3BY8B3aQNJrNyr2"};